/** #@condition: vision, genbet **/
export default {
    coupon: {
        marketLabelToType: {
            ASIAN_TOTALS: ['ASOU'],
            BTTS: ['BTSC'],
            SET_HANDICAP: ['MSSF'],
            LEG_HANDICAP: ['ALHS'],
            HANDICAP: [
                'AHHT',
                'CHCM',
                'HCMR',
                'HO3F',
                'HOT3',
                'FHMR',
                'FHC2',
                'CHCO',
                'FAHC',
                'CAHC',
                'CCRH',
                'FAHP',
                'HCOT',
                'FHOT',
                'CAHH',
                'FAHT',
                'CAH2',
                'AH1P',
                'AH2P',
                'AH4P',
                'CT4H',
                'AH3P',
                'CT1H',
                'CT2H',
                'CT3H',
                '5FHC',
                'C5IR',
                'CTGH',
                'S1HC',
                'S1HF',
                'MSSH',
                'SNHC',
                'CTSH',
                'TGHC',
                'H2OF',
                'T1HC',
                'FA1P',
                'T2HC',
                'FA2P',
                'T3HC',
                'FA3P',
                'T4HC',
                'FA4P',
                'AH2O',
                'GHCS',
                'TSHC',
                '5IRL',
                'PAHC',
                'AHCP',
                'PHCM',
                'HCA3',
                'MGHC',
            ],
            HT_RESULTS: ['H1RS'],
            MATCH_WINNER_HA: [
                'DNOB',
                'HHTT',
                'HHTP',
                'HHPP',
                'HHPT',
                'H2HT',
                'H2H1',
                'HHH1',
                'HH1B',
                '1DNB',
                'HH2H',
                'HTOH',
                '2DNB',
                'HHH2',
                'T1ML',
                'T1DN',
                'T2ML',
                'T2DN',
                'T3DN',
                'T3ML',
                'T4ML',
                'T4DN',
                '5IWD',
                'TXML',
                'MOLI',
            ],
            MATCH_WINNER_HDA: ['MRES', 'MR12', 'T1WN', 'T2WN', 'T3WN', 'MREP'],
            MOST_180S: ['M180'],
            SET_WINNER: ['STWN', 'STWT'],
            TOTAL_180S: ['180F'],
            TOTAL_GOALS: [
                'O3OT',
                'HCTG',
                'COUG',
                'CCRO',
                'FOUT',
                'FTPO',
                'COUT',
                'CTPO',
                'CTGO',
                'CH1T',
                'COH1',
                'COH2',
                'CO2H',
                'FP1O',
                'FP2O',
                'FP3O',
                'FP4O',
                'CP1O',
                'CP2O',
                'CP3O',
                'O3TF',
                '5ITR',
                'C5FT',
                'F5FT',
                'TGOU',
                'TPOT',
                'FTGO',
                'H1TP',
                'OU2E',
                'P1OU',
                'P2OU',
                'P3OU',
                'P4OU',
                '5FTO',
                'F1TP',
                'OH1M',
                'O2HO',
                'OUTG',
                'OUTP',
                'STOU',
                'TGOS',
            ],
            TOTAL: ['S1OU', 'TSMF'],
            TOTAL_TRIES: ['CTTO', 'TTFO', 'TTOU'],
            TOTAL_RUNS: ['INOU'],
            GO_THE_DISTANCE: ['BGTD'],
            TOSS_WIN: ['TWTT'],
            DOUBLE_CHANCE: ['DBLC'],
            TOTAL_FRAMES: ['TFOU'],
            FRAME_WINNER: ['FMWN'],
            PLAYER_SPECIALS: ['PLSP'],
            TEAM_SPECIALS: ['TMSP'],
            NEXT_TEAM_TO_SCORE: ['INTS'],
            CORNER_3_WAY: ['COH3', 'COF3'],
            GAME_WINNER: ['SGMW'],
            FIRST_HALF: ['OUH1'],
            ODD_EVEN: ['OEOT'],
            ET_MATCH_WINNER_HDA: ['ETRS'],
            ET_FIRST_HALF: ['E1RS'],
            ET_TOTAL_GOALS: ['HCEG'],
            SCORE_GOAL_IN_BOTH_HALVES: ['GSBH'],
            HALF_TIME_FULL_TIME: ['HTFT'],
        },
        gameLineLabelToType: {
            // copy of this.coupon.marketLabelToType.HANDICAP
            SPREAD: [
                'AHHT',
                'CHCM',
                'HCMR',
                'HO3F',
                'HOT3',
                'FHMR',
                'FHC2',
                'CHCO',
                'FAHC',
                'CAHC',
                'CCRH',
                'FAHP',
                'HCOT',
                'FHOT',
                'CAHH',
                'FAHT',
                'CAH2',
                'AH1P',
                'AH2P',
                'AH4P',
                'CT4H',
                'AH3P',
                'CT1H',
                'CT2H',
                'CT3H',
                '5FHC',
                'C5IR',
                'CTGH',
                'S1HC',
                'S1HF',
                'MSSF',
                'MSSH',
                'SNHC',
                'CTSH',
                'TGHC',
                'H2OF',
                'T1HC',
                'FA1P',
                'T2HC',
                'FA2P',
                'T3HC',
                'FA3P',
                'T4HC',
                'FA4P',
                'AH2O',
                'GHCS',
                'TSHC',
                '5IRL',
                'PAHC',
                'AHCP',
                'PHCM',
                'HCA3',
                'MGHC',
            ],
            // copy of this.coupon.marketLabelToType.MATCH_WINNER_HA
            MONEY: [
                'DNOB',
                'HHTT',
                'HHTP',
                'HHPP',
                'HHPT',
                'H2HT',
                'H2H1',
                'HHH1',
                'HH1B',
                '1DNB',
                'HH2H',
                'HTOH',
                '2DNB',
                'HHH2',
                'T1ML',
                'T1DN',
                'T2ML',
                'T2DN',
                'T3DN',
                'T3ML',
                'T4ML',
                'T4DN',
                '5IWD',
                'TXML',
                'MOLI',
            ],
            // copy of this.coupon.marketLabelToType.MATCH_WINNER_HDA
            RESULT: ['MRES', 'MR12', 'T1WN', 'T2WN', 'T3WN', 'MREP'],
            // copy of this.coupon.marketLabelToType.TOTAL_GOALS
            TOTAL: [
                'O3OT',
                'HCTG',
                'ASOU',
                'COUG',
                'CCRO',
                'FOUT',
                'FTPO',
                'COUT',
                'CTPO',
                'CTGO',
                'CH1T',
                'COH1',
                'COH2',
                'CO2H',
                'FP1O',
                'FP2O',
                'FP3O',
                'FP4O',
                'CP1O',
                'CP2O',
                'CP3O',
                'O3TF',
                '5ITR',
                'C5FT',
                'F5FT',
                'TGOU',
                'TPOT',
                'FTGO',
                'H1TP',
                'OU2E',
                'P1OU',
                'P2OU',
                'P3OU',
                'P4OU',
                '5FTO',
                'F1TP',
                'OH1M',
                'O2HO',
                'OUTG',
                'OUTP',
                'STOU',
                'TGOS',
            ],
        },
        marketToSelections: {
            '180F': ['Over', 'Under'],
            '1DNB': ['P1', 'P2'],
            '2DNB': ['P1', 'P2'],
            '5IWD': ['1', '2'],
            AH2O: ['1', '2'],
            AOH1: ['Over', 'Under'],
            ASOU: ['Over', 'Under'],
            BTOF: ['P1', 'P2'],
            BTSC: ['Yes', 'No'],
            C5FT: ['Over', 'Under'],
            C5IR: ['1', '2'],
            CAHH: ['1', '2'],
            CHCO: ['P1', 'P2'],
            CO2H: ['Over', 'Under'],
            COF3: ['Over', 'Under', 'Exactly'],
            COH1: ['Over', 'Under'],
            COUT: ['Over', 'Under'],
            CP1O: ['Over', 'Under'],
            CP2O: ['Over', 'Under'],
            CP3O: ['Over', 'Under'],
            CP4O: ['Over', 'Under'],
            CT1H: ['1', '2'],
            CT2H: ['1', '2'],
            CT3H: ['1', '2'],
            CT4H: ['1', '2'],
            CTGH: ['1', '2'],
            CTGO: ['Over', 'Under'],
            CTPO: ['Over', 'Under'],
            CTSH: ['1', '2'],
            CTTO: ['Over', 'Under'],
            DBLC: ['1X', '12', 'X2'],
            DNOB: ['1', '2'],
            FAHC: ['1', '2'],
            FHMR: ['1', 'X', '2'],
            FMWN: ['1', '2'],
            FTGO: ['Over', 'Under'],
            FOUT: ['Over', 'Under'],
            GSBH: ['Yes', 'No'],
            H1RS: ['1', 'X', '2'],
            H2HT: ['P1', 'P2'],
            H2H1: ['P1', 'P2'],
            H2RS: ['P1', 'P2'],
            HCMR: ['1', 'X', '2'],
            HCTG: ['Over', 'Under'],
            HH2H: ['P1', 'P2'],
            HHH1: ['P1', 'P2'],
            HHPP: ['1', '2'],
            HHPT: ['1', '2'],
            HHTT: ['1', '2'],
            HHTP: ['1', '2'],
            HO3F: ['1', 'X', '2'],
            HTFT: ['1', 'X', '2'],
            HTOH: ['P1', 'P2'],
            INTS: ['Home', 'NoGoal', 'Away'],
            MREP: ['1', 'X', '2'],
            M180: ['1', 'X', '2'],
            MRES: ['1', 'X', '2'],
            MR12: ['1', 'X', '2'],
            MSSF: ['P1', 'P2'],
            NMST: ['3', '4', '5'],
            ODEV: ['Odd', 'Even'],
            OEOT: ['Odd', 'Even'],
            OU2E: ['Over', 'Under'],
            OUH1: ['Over', 'Under'],
            QUAL: ['1', '2'],
            RDOU: ['Over', 'Under'],
            S1OU: ['Over', 'Under'],
            STWN: ['P1', 'P2'],
            STWT: ['P1', 'P2'],
            T1DN: ['1', '2'],
            T1ML: ['1', '2'],
            T2DN: ['1', '2'],
            T3DN: ['1', '2'],
            T4DN: ['1', '2'],
            TGOU: ['Over', 'Under'],
            TFOU: ['Over', 'Under'],
            TPOT: ['Over', 'Under'],
            TSMF: ['Over', 'Under'],
            SNHC: ['1', '2'],
            NRES: ['1', 'X', '2'],
            S1HC: ['1', '2'],
            MOLI: ['1', '2'],
            OUTP: ['Over', 'Under'],
            TTOU: ['Over', 'Under'],
            PHCM: ['1', 'X', '2'],
            HCA3: ['1', 'X', '2'],
            INOU: ['Over', 'Under'],
            AHCP: ['1', '2'],
            FTPO: ['Over', 'Under'],
            FAHP: ['1', '2'],
            STOU: ['Over', 'Under'],
            GHCS: ['1', '2'],
            ALHS: ['1', '2'],
            PAHC: ['1', '2'],
            TWTT: ['1', '2'],
            TTFO: ['Over', 'Under'],
            TGOS: ['Over', 'Under'],
            TSHC: ['1', '2'],
            BGTD: ['Yes', 'No'],
            MGHC: ['1', '2'],
            TGHC: ['1', '2'],
            ETRS: ['1', 'X', '2'],
            E1RS: ['1', 'X', '2'],
            HCEG: ['Over', 'Under'],
            MTOT: ['Over', 'Under'],
        },
        // todo
        config: {
            american_football: {
                gameLines: [
                    {
                        label: 'GAME_LINE',
                        lines: [{types: ['HCOT', 'FHOT']}, {types: ['H2HT']}, {types: ['TPOT', 'FTPO']}],
                    },
                    {
                        label: 'FIRST_HALF',
                        lines: [{types: ['AHHT']}, {types: ['1DNB']}, {types: ['H1TP']}],
                    },
                    {
                        label: 'SECOND_HALF',
                        lines: [{types: ['H2OF']}, {types: ['2DNB', 'HH2H']}, {types: ['OU2E']}],
                    },
                    {
                        label: 'FIRST_QUARTER',
                        lines: [{types: ['T1HC', 'FA1P']}, {types: ['T1ML']}, {types: ['P1OU']}],
                    },
                    {
                        label: 'SECOND_QUARTER',
                        lines: [{types: ['T2HC', 'FA2P']}, {types: ['T2ML']}, {types: ['P2OU']}],
                    },
                    {
                        label: 'THIRD_QUARTER',
                        lines: [{types: ['T3HC', 'FA3P']}, {types: ['T3ML']}, {types: ['P3OU']}],
                    },
                    {
                        label: 'FOURTH_QUARTER',
                        lines: [{types: ['T4HC', 'FA4P']}, {types: ['T4ML']}, {types: ['P4OU']}],
                    },
                ],
            },
            baseball: {
                gameLines: [
                    {
                        label: 'GAME_LINE',
                        lines: [
                            {types: ['HHTT', 'HHPP', 'HHPT', 'HHTP']},
                            {types: ['FHOT', 'HCOT']},
                            {types: ['TPOT', 'FTPO']},
                        ],
                    },
                    {
                        label: 'THREE_WAY_MARKETS',
                        lines: [{types: ['HOT3']}, {types: ['O3OT']}],
                    },
                    {
                        label: 'FIVE_INNINGS',
                        lines: [{types: ['5IWD']}, {types: ['AHHT']}, {types: ['5FTO']}],
                    },
                ],
            },
            basketball: {
                gameLines: [
                    {
                        label: 'GAME_LINE',
                        lines: [
                            {types: ['HCOT', 'FHOT', 'FAHC']},
                            {types: ['TPOT', 'FTPO', 'OUTP']},
                            {types: ['H2HT', 'MOLI']},
                        ],
                    },
                    {
                        label: 'FIRST_HALF',
                        lines: [{types: ['AHHT', 'FAHT']}, {types: ['OH1M', 'F1TP']}, {types: ['1DNB', 'HHH1']}],
                    },
                    {
                        label: 'SECOND_HALF',
                        lines: [{types: ['AH2O']}, {types: ['OU2E', 'O2HO']}, {types: ['HH2H', '2DNB']}],
                    },
                    {
                        label: 'FIRST_QUARTER',
                        lines: [{types: ['T1HC', 'FA1P']}, {types: ['P1OU', 'FP1O']}, {types: ['T1DN', 'T1ML']}],
                    },
                    {
                        label: 'SECOND_QUARTER',
                        lines: [{types: ['T2HC', 'FA2P']}, {types: ['P2OU', 'FP2O']}, {types: ['T2DN', 'T2ML']}],
                    },
                    {
                        label: 'THIRD_QUARTER',
                        lines: [{types: ['T3HC', 'FA3P']}, {types: ['P3OU', 'FP3O']}, {types: ['T3DN', 'T3ML']}],
                    },
                    {
                        label: 'FOURTH_QUARTER',
                        lines: [{types: ['T4HC', 'FA4P']}, {types: ['P4OU', 'FP4O']}, {types: ['T4DN', 'T4ML']}],
                    },
                ],
            },
            ice_hockey: {
                gameLines: [
                    {
                        label: 'GAME_LINE',
                        lines: [{types: ['HCOT', 'FAHC', 'FHOT']}, {types: ['H2HT']}, {types: ['OUTG', 'TPOT']}],
                    },
                    {
                        label: 'FIRST_PERIOD',
                        lines: [{types: ['T1HC']}, {types: ['T1WN']}, {types: ['P1OU', 'FP1O']}],
                    },
                    {
                        label: 'SECOND_PERIOD',
                        lines: [{types: ['T2HC']}, {types: ['T2WN']}, {types: ['P2OU', 'FP2O']}],
                    },
                    {
                        label: 'THIRD_PERIOD',
                        lines: [{types: ['T3HC']}, {types: ['T3WN']}, {types: ['P3OU', 'FP3O']}],
                    },
                    {
                        label: 'THREE_WAY_MARKETS',
                        lines: [{types: ['MRES']}, {types: ['HCMR']}],
                    },
                ],
            },
            australian_football: {
                preplay: [{types: ['FAHC']}, {types: ['H2HT', 'DNOB']}],
            },
            badminton: {
                preplay: [{types: ['HTOH']}],
            },
            bandy: {
                preplay: [{types: ['MRES', 'MR12']}],
            },
            beach_soccer: {
                preplay: [{types: ['MRES', 'MR12']}, {types: ['HCTG']}],
            },
            beach_volleyball: {
                preplay: [{types: ['H2HT']}, {types: ['STWT']}, {types: ['OUTP']}],
            },
            bowls: {
                preplay: [{types: ['HTOH']}],
            },
            boxing: {
                preplay: [{types: ['MREP']}, {types: ['HTOH']}, {types: ['BGTD']}],
            },
            cricket: {
                preplay: [{types: ['H2HT', 'DNOB', 'MRES', 'MR12']}],
            },
            curling: {
                preplay: [{types: ['H2HT']}],
            },
            darts: {
                preplay: [
                    {types: ['HTOH']},
                    {types: ['S1HC', 'S1HF', 'MSSF', 'MSSH', 'ALHS']},
                    {types: ['S1OU', 'TSMF']},
                    {types: ['180F']},
                    {types: ['M180']},
                ],
                inplay: [{types: ['HTOH']}, {types: ['S1HC', 'S1HF', 'ALHS', 'MSSF', 'MSSH']}],
            },
            esports: {
                preplay: [{types: ['H2HT', 'HTOH', 'MOLI'], 'fallback-types': ['HCTG']}, {types: ['MRES']}],
                inplay: [{types: ['H2HT', 'HTOH', 'MOLI'], 'fallback-types': ['HCTG']}, {types: ['MRES']}],
            },
            field_hockey: {
                preplay: [{types: ['MRES', 'MR12']}],
            },
            floorball: {
                preplay: [{types: ['MRES', 'MR12']}, {types: ['HCTG']}],
            },
            // copy of this.coupon.config.soccer
            football: {
                preplay: [
                    {types: ['MRES', 'MR12']},
                    {types: ['HCTG', 'COUG']},
                    {types: ['HCMR']},
                    {types: ['BTSC']},
                    {types: ['H1RS']},
                ],
                inplay: [
                    {
                        types: ['MRES', 'MR12'],
                        'fallback-types': ['HCTG', 'ETRS', 'HCEG'],
                    },
                    {types: ['HCTG', 'COUG']},
                    {types: ['HCMR']},
                    {types: ['BTSC']},
                    {
                        types: ['H1RS'],
                        'fallback-types': ['E1RS'],
                    },
                ],
            },
            futsal: {
                preplay: [{types: ['MRES', 'MR12']}, {types: ['HCTG']}],
                inplay: [{types: ['MRES', 'MR12']}, {types: ['HCTG']}],
            },
            gaa_football: {
                preplay: [{types: ['MRES', 'MR12']}],
            },
            gaelic_games: {
                preplay: [{types: ['MRES']}, {types: ['HCMR']}],
            },
            handball: {
                preplay: [{types: ['MRES', 'MR12']}, {types: ['HCTG']}, {types: ['FAHC']}],
                inplay: [{types: ['MRES', 'MR12']}, {types: ['HCTG']}, {types: ['FAHC']}],
            },
            jai_alai: {
                preplay: [{types: ['HTOH']}],
            },
            martial_arts: {
                preplay: [{types: ['HTOH']}],
            },
            motorsport: {
                preplay: [{types: ['HTOH']}],
            },
            padel: {
                preplay: [{types: ['HTOH']}],
            },
            pesapallo: {
                preplay: [{types: ['MRES', 'MR12']}],
            },
            pool: {
                preplay: [{types: ['HTOH']}],
            },
            rugby_league: {
                preplay: [{types: ['HCMR', 'FHMR']}, {types: ['OUTP', 'FOUT']}, {types: ['MRES']}],
            },
            rugby_union: {
                preplay: [{types: ['HCMR', 'FHMR']}, {types: ['OUTP', 'FOUT']}, {types: ['MRES']}],
            },
            snooker: {
                preplay: [{types: ['MREP']}, {types: ['SNHC']}, {types: ['TFOU']}, {types: ['FMWN']}],
                inplay: [{types: ['MREP']}, {types: ['SNHC']}, {types: ['TFOU']}, {types: ['FMWN']}],
            },
            soccer: {
                preplay: [
                    {types: ['MRES', 'MR12']},
                    {types: ['HCTG', 'COUG']},
                    {types: ['HCMR']},
                    {types: ['BTSC']},
                    {types: ['H1RS']},
                ],
                inplay: [
                    {
                        types: ['MRES', 'MR12'],
                        'fallback-types': ['HCTG', 'ETRS', 'HCEG'],
                    },
                    {types: ['HCTG', 'COUG']},
                    {types: ['HCMR']},
                    {types: ['BTSC']},
                    {types: ['H1RS'], 'fallback-types': ['E1RS']},
                ],
            },
            soccer_1v1: {
                preplay: [{types: ['MRES']}],
            },
            table_tennis: {
                preplay: [{types: ['HTOH']}],
            },
            tennis: {
                preplay: [{types: ['HTOH']}, {types: ['TGHC', 'MGHC']}, {types: ['FTGO']}],
                inplay: [{types: ['HTOH']}, {types: ['STWN']}, {types: ['FTGO']}],
            },
            volleyball: {
                preplay: [{types: ['H2HT']}, {types: ['STWT']}],
                inplay: [{types: ['H2HT']}, {types: ['STWT']}, {types: ['OUTP']}],
            },
            waterpolo: {
                preplay: [{types: ['MRES', 'MR12']}, {types: ['TPOT']}],
            },
        },
    },
    goal_scorer_market_type_to_mask: {
        FGSC: 'FIRST',
        INXP: 'NEXT',
        LGSC: 'LAST',
        HATR: 'HAT_TRICK',
        PTS2: 'PLUS2',
        PSCN: 'ANYTIME',
    },
    handicap_market_types: [
        'CTPO',
        'TPOT',
        'FTPO',
        'FOAP',
        'TPAO',
        'FOHP',
        'TPHO',
        'FTP2',
        'TRAT',
        'TRHT',
        'F5FT',
        'FH1A',
        'FH1H',
        'HTTH',
        'ATTH',
        'I1T5',
        'COUA',
        'OUAP',
        'COUH',
        'OUHP',
        'COUG',
        'HCTG',
        'OUAO',
        'OUHO',
        'OUAG',
        'OUHG',
        'OUH1',
        'ASOU',
        'OU1H',
        'OU1A',
        'FTGO',
        'FTP2',
        'TRAT',
        'TRHT',
        'F5FT',
        'HCOT',
        'FHOT',
        'CHCO',
        'FHC2',
        'TGHC',
        'I15A',
        'I15H',
        'CH23',
        'CHCM',
        'CHF3',
        'CHH3',
        'CO23',
        'COF3',
        'COH3',
        'FH3C',
        'FHH1',
        'FHMR',
        'HCA3',
        'HCH1',
        'HCH2',
        'HCMR',
        'HOT3',
        'O3OT',
        'TMBH',
        'OUH2',
        'COU1',
        'CNOU',
        'FXC2',
        'FYC2',
        'ACOU',
        'HCOU',
        'CCOU',
        'OUTG',
        'FP1O',
        'FHTG',
        'OTCP',
        'SHTA',
        'STDS',
        'FCH2',
        'AHRF',
        'INGB',
        'OTCO',
        'TBPS',
        'FSTO',
        'DQ1H',
        'GKAO',
        'FD2B',
        'P3OU',
        'YCOU',
        'FAHC',
        'TPAT',
        'AHPR',
        'DH2B',
        'GOUP',
        'P4HO',
        'COE3',
        'GKHO',
        'DQ4A',
        'YO22',
        'YOU2',
        'H2RG',
        'CHE3',
        'HCPO',
        'PSHO',
        'HC2F',
        'TRYD',
        'FD1B',
        'DQ1B',
        'FQ3B',
        'FO34',
        'H2OF',
        'T1HC',
        '1FOU',
        'FQ2H',
        'LFGG',
        'TPYC',
        'STSD',
        'CT2H',
        'OU2H',
        'P1AO',
        'FCH3',
        'OU2E',
        'AHR2',
        'HCP3',
        'OTCE',
        'COU2',
        'FO33',
        'FAH2',
        'OH1M',
        'TRUY',
        'OTFK',
        'RMOU',
        'YOHP',
        'CT1H',
        'CHE2',
        'HTHH',
        'DH2A',
        'XQAT',
        'DH1H',
        'FQ1B',
        'OTGA',
        'OUPA',
        'FCAB',
        'P3HO',
        'FH2H',
        'LTSD',
        'FH2A',
        '2O3F',
        'HCET',
        'OUPO',
        'XOH2',
        'DQ2B',
        'CP2O',
        'OU2A',
        'CH1T',
        'DQ3H',
        'AHGK',
        'FH2C',
        'P4OU',
        'T2HC',
        'CH22',
        'FP2O',
        'CAH2',
        'BSOH',
        '1COU',
        'FQ4B',
        'YOF2',
        'P2HO',
        'OOUE',
        'FQ4A',
        'HCCN',
        'DQ3A',
        '1OU3',
        'YOU1',
        'OTGK',
        '1CPO',
        'TFGG',
        'YOE2',
        'ADCY',
        'FHEA',
        'GKA2',
        'O3TF',
        'O2HO',
        'TPCC',
        'PSAO',
        'R1OU',
        'AH2P',
        'DQ3B',
        'FA2P',
        'FQ2B',
        'HTCE',
        'AHH2',
        'OVUN',
        'FD1H',
        'AOOU',
        'XO22',
        'P3AO',
        'AOH1',
        'MSSF',
        'AH2F',
        'FHOU',
        'COEH',
        'ACPO',
        'FQ3H',
        '1TOU',
        'PRYS',
        'PRUS',
        'CP4O',
        'CO2H',
        'TRCP',
        'OTGH',
        'FYH2',
        'ATCE',
        'O3P3',
        'CHF2',
        'P4AO',
        'TRRY',
        'FA4P',
        'CP1O',
        'AHRH',
        'XOF2',
        'TPST',
        'AH4P',
        'DQ1A',
        'LFGS',
        'PNTO',
        'H1HP',
        'TSCK',
        'HC3F',
        'BSOU',
        'RMTG',
        'FP3O',
        'AOU1',
        'OTTI',
        'PTUO',
        'OUFH',
        'GAFT',
        'O3P1',
        'CHRF',
        'FT2H',
        'HCEG',
        'E2FO',
        'XOE2',
        'AHE1',
        'O3P2',
        'TCOU',
        'P1OU',
        'TIOU',
        'FQ3A',
        'FCB2',
        'FD2A',
        'P2OU',
        'HFOU',
        'AHCA',
        'HOOU',
        'O3P4',
        'TGMN',
        'YOH2',
        'FP4O',
        '1OOU',
        'OTCA',
        'YOUP',
        'OUPR',
        'TPPO',
        'DQ2H',
        'TOOU',
        'HC2H',
        'H2HO',
        'FD2H',
        'H1GF',
        'DO1H',
        'AHOF',
        'TARS',
        '1O3F',
        'FO31',
        'AWTC',
        'CAHH',
        'PRUT',
        'XQHT',
        'AH1P',
        'D1BF',
        'TGET',
        'HOTC',
        'PSHA',
        'LPRG',
        'DQ4B',
        'YOUA',
        'CT4H',
        'ANGB',
        'OUFA',
        'CPH2',
        'OUPH',
        'THOU',
        'SPOU',
        'TPEN',
        'HC1F',
        'AHXM',
        'STOU',
        'FQ2A',
        'FA1P',
        'R1TG',
        'FD1A',
        '2OU3',
        'AHTH',
        'DH1A',
        'H2TP',
        'ATHH',
        'P1HO',
        'YOAP',
        'AHCP',
        'PSQT',
        'OTOF',
        'H1TP',
        'F2TP',
        'E1OU',
        'FGB2',
        'RCOU',
        'D1AF',
        'DH2H',
        'H2AP',
        'MROD',
        'FXH2',
        'AHHT',
        'E2OU',
        'HCAP',
        'TPNT',
        'HCP1',
        'CHH2',
        'D1HF',
        'F1TP',
        'FKOU',
        'FO32',
        'HNGB',
        'TPSO',
        'FCE2',
        'TCOE',
        'DO1B',
        'AH2O',
        'FQ1H',
        'CT3H',
        'TRAD',
        'PLPT',
        'AHPS',
        'H1AP',
        'AHE2',
        'DQ4H',
        'HO3F',
        'TTOT',
        'SHTH',
        'FA3P',
        'FAHT',
        'HC4F',
        'FQ4H',
        'FG2F',
        'FHEH',
        'CP3O',
        'LPCC',
        'T4HC',
        'COUE',
        'P2AO',
        'LTDS',
        'AHFK',
        'OTGO',
        'OH2M',
        'OUTP',
        'DO1A',
        'AH3P',
        'FQ1A',
        'H2HP',
        'AH2H',
        'DCTG',
        'DQ2A',
        'E1FO',
        'HCP4',
        'DH1B',
        'GKOU',
        'TPTC',
        'AOH2',
        'YOUH',
        'HCP2',
        'TMS2',
        'AHRE',
        'PLTT',
        'AHCE',
        'TPOU',
        '1GOU',
        'OUPT',
        'PLSO',
        'PLSG',
        'PASO',
        'PYOU',
        'PTPS',
        'PTRU',
        'PRYS',
        'PTRE',
        'PTRS',
        'PPTO',
        'TPTS',
        'RCTP',
        'PRUS',
        'PTIS',
        'PRAS',
        'PRRS',
        'PPCS',
        'PTPR',
        'PLAS',
        '1HRC',
        'PTFT',
        'PTKP',
        'PROU',
        'PCOU',
        'PTPC',
        'PTSS',
        'PIOU',
        'PPCT',
        'PPTT',
        'PPYT',
        'PRAT',
        'PRYL',
        'PRYT',
        'ROUP',
        'MTOT',
        'H1RG',
        'H2RG',
        'MLOU',
    ],
    correct_score_market_types: [
        'C4H1',
        'C4H2',
        'C6H1',
        'C6H2',
        'CFSU',
        'CS04',
        'CS05',
        'CS6O',
        'CSF4',
        'CSFO',
        'CSFT',
        'CSHT',
        'CSH2',
        'P1CS',
        'P2CS',
        'P3CS',
        'PSCS',
        'CSOO',
        'CSO1',
        'CSOT',
        'E1CL',
        'ECS3',
        'ECSL',
        'OTCS',
        'PCSO',
    ],
    player_prop_market_types: [
        'PLSO',
        'PLSG',
        'PASO',
        'PRUO',
        'PYOU',
        'PTPS',
        'PTRU',
        'PRYS',
        'PTRE',
        'PTRS',
        'PPTO',
        'TPTS',
        'RCTP',
        'PRUS',
        'PTIS',
        'PTPA',
        'PRAS',
        'TPRS',
        'PRRS',
        'PPCS',
        'PLRS',
        'PTPR',
        'PLCS',
        'PLRU',
        'PTTS',
        'PLPO',
        'TPLP',
        'PLAS',
        'TPLA',
        'PLRE',
        'TPLR',
        '3PFG',
        '3POU',
        'PLBL',
        'PLSL',
        'PLTU',
        'PLPA',
        'BRAB',
        'PLDD',
        'PLTD',
        'PREA',
        'SPAR',
        'STBL',
        'FTMA',
        'FTAT',
        'FGMA',
        'FGAT',
        'TWMA',
        'TATT',
        'TPSS',
        'PTGS',
        'PTAS',
        'PBSS',
        'PGAS',
        'TSPS',
        'PPPS',
        'PPMS',
        'SPTS',
        'PHRO',
        'POUS',
        'PTBO',
        'PTHO',
        'PTRO',
        'PSBT',
        'PSOU',
        'PDOU',
        'PTTO',
        'PRBI',
        'HRRT',
        'POUT',
        'PWTO',
        'PERT',
        'PHAO',
        'PBST',
        'PBWT',
        'PIOT',
        'PFQP',
        'PFQA',
        'PFQR',
        'PEFO',
        'TTAT',
        '1PPY',
        '2PPY',
        '1QPP',
        '2QPP',
        '3QPP',
        '4QPP',
        '1HPT',
        '2HPT',
        '1QPT',
        '2QPT',
        '3QPT',
        '4QPT',
        '1HRY',
        '2HRY',
        '1QRY',
        '1HRT',
        '2HRT',
        '1HRU',
        '2HRU',
        '1QRU',
        '1RUT',
        '2RUT',
        '1QRT',
        '1HIN',
        '2HIN',
        '1QIN',
        '1HPA',
        '2HPA',
        '1QPA',
        '1HRA',
        '2HRA',
        '1QRA',
        '1HRC',
        '2HRC',
        '1QRC',
        '1HRR',
        '2HRR',
        '1QRR',
        '1HPC',
        '2HPC',
        '1QPC',
        'P3OO',
        'PAOO',
        'PARO',
        'PBOO',
        'LPPC',
        'LPRT',
        'PDIT',
        'PFGM',
        'PIOU',
        'PKPT',
        'PPAT',
        'PPCT',
        'PPRY',
        'PPTT',
        'PPAO',
        'PPRO',
        'PRAO',
        'PROO',
        'PSBO',
        'PSOO',
        'PTOO',
        'PYDD',
        'PYTD',
        'PPYT',
        'PRAT',
        'PRRY',
        'PRYL',
        'PRYT',
        'PTAL',
        'ROUP',
        'LHRR',
        'LPDU',
        'LPHR',
        'LPLH',
        'LPPO',
        'LPRB',
        'LPRE',
        'LPSO',
        'LPST',
        'LPTB',
        'LRUN',
        'LSIN',
        'LTRI',
        'PPOO',
        'PSOT',
        'ATYN',
        'BAFS',
        'FGYN',
        'LGYN',
        'PFER',
        'PFHI',
        'PFHR',
        'PFM2',
        'PFM3',
        'PFMT',
        'PFRU',
        'PFSO',
        'PLSH',
        'PLWI',
        'PTFT',
        'PTLT',
        'PTKP',
        'PROU',
        'PCOU',
        'PTPC',
        'PTSS',
        'PDDO',
        'PTUO',
        'FRBI',
        '1IPR',
        '1NOE',
        '1NPC',
        '2IPR',
        '2NOE',
        '2NPC',
        '2P25',
        '2P50',
        '2P75',
        '2PH2',
        '2PH3',
        '2PH6',
        '2PHH',
        '2PSC',
        '2PSH',
        'BP25',
        'BP50',
        'BP75',
        'BPH2',
        'BPH3',
        'BPH6',
        'BPHH',
        'PL24',
        'PL26',
        'PLY4',
        'PLY6',
        'PTCH',
        'PTCT',
    ],
    player_milestone_market_types: [
        'PALA',
        'PALG',
        'PALP',
        'PALS',
        'PLST',
        'PLTA',
        'PPTD',
        'PLPY',
        'PLPC',
        'PREY',
        'PLRY',
        'PALR',
        'PALC',
        'PLNT',
        'PLTB',
        'PLBH',
        'PBHR',
        'PBRR',
        'PLPS',
        'PLTR',
        'PLNP',
        'P3PG',
        'PLNS',
        'PALB',
        'PTST',
        'PKCK',
        'PLAP',
        'PLDP',
        'PLER',
        'PLFG',
        'PLFP',
        'PLHB',
        'PLHR',
        'PLNH',
        'PLNR',
        'PLRT',
        'PLSV',
        'PLTO',
        'PMRK',
        'PNSO',
        'PNTB',
        'PRET',
    ],
    player_incident_market_types: [
        'PXAS',
        'PXFL',
        'PXFW',
        'PXHS',
        'PXLF',
        'PXOB',
        'PXOS',
        'PXRF',
        'PXSH',
        'PXSO',
        'PXSV',
        'PXTK',
        'PXSA',
    ],
    three_way_market_types: ['MRBT'],
    set_score_market_types: ['STSC'],
    three_way_handicap_market_types: ['H1RG', 'H2RG', 'MROU', 'DCTG'],
    eventGroupsConfig: {
        eventGroupsFilter: {
            future: {
                medium: {
                    maxNumberOfEvents: 10,
                    timeFilter: {
                        default: 24,
                        american_football: 96,
                        australian_football: 192,
                        badminton: 96,
                        baseball: 48,
                        basketball: 48,
                        boxing: 168,
                        cricket: 96,
                        darts: 96,
                        floorball: 96,
                        futsal: 72,
                        gaelic_games: 168,
                        handball: 96,
                        ice_hockey: 96,
                        rugby_league: 72,
                        rugby_union: 72,
                        snooker: 96,
                        soccer: 48,
                        tennis: 48,
                        volleyball: 96,
                    },
                },
            },
            live: {
                small: {
                    maxNumberOfEvents: 10,
                },
            },
            'live-and-future': {
                medium: {
                    maxNumberOfEvents: 10,
                },
            },
        },
    },
    virtualJobMap: {
        defaultVirtuals: {
            timeToShowAfterLive: 2,
            numOfEvents: 10,
        },
        virtuals: {
            virtual_soccer: {
                active: true,
            },
            virtual_greyhound_racing: {
                active: true,
            },
            virtual_horse_racing: {
                active: true,
            },
            virtual_tennis: {
                active: true,
            },
            virtual_basketball: {
                active: true,
            },
            virtual_motorsport: {
                active: true,
            },
            virtual_cycling: {
                active: true,
            },
            virtual_motorcycling: {
                active: true,
            },
            virtual_ice_hockey: {
                active: true,
            },
            virtual_trotting: {
                active: true,
            },
            virtual_football: {
                active: true,
            },
        },
    },
    feedProvider: 'GENBET',
};
